module.exports = __webpack_public_path__ + "img/icon_up_result_pop__002.46327244.png";